export default {
  // Main navigation menu
  home: "Home",
  analysisAndResearch: "Analysis & Research",
  evidenceManagement: "Evidence Management",
  dataBoard: "Data Board",
  caseToolbox: "Case Toolbox",
  helpCenter: "Help Center",
  apiService: "APIs",
  permissionManagement: "Permission Management",

  // Analysis & Research submenu
  caseAnalysis: "Case Analysis",
  balanceAnalysis: "Balance Analysis",
  labelManagement: "Label Management",
  aiModel: "AI Model",
  addressMonitoring: "Address Monitoring",
  remarkManagement: "Remark Management",

  // Evidence Management submenu
  evidenceAdvice: "Evidence Advice",
  evidenceUsers: "Evidence Users",
  evidenceUpload: "Evidence Upload",
  evidenceInvestigation: "Evidence Investigation",

  // Data Board submenu
  transactionData: "Transaction Data",
  balanceData: "Balance Data",

  // Case Toolbox submenu
  addressCompletion: "Address Completion",
  hashCompletion: "Hash Completion",
  tgSentimentAnalysis: "TG Public Group Sentiment",

  // Help Center submenu
  productFunction: "Product Function Introduction",
  judicialReference: "Judicial Reference",
  prosecutionBook: "Prosecution Book",
  policyRegulation: "Policy Regulation",
  blockchainKnowledge: "Blockchain Industry Knowledge",
  blockchainCaseInvestigation: "Blockchain Case Investigation Records",

  // Permission Management submenu
  labelList: "Label Management",
  userList: "User List",
  roleManagement: "Role Management",
  userLog: "User Log",
  adminLog: "Admin Log",

  // Others
  dataLargeScreen: "Data Large Screen",
  userCenter: "User Center",
  userFeedback: "User Feedback",
  logout: "Logout",
};
